import {mapGetters} from 'vuex';
export default {
    computed:{
        ...mapGetters(['couponData']),
        productPrice(){
            return (this.order.details.price_per_unit * this.order.details.quantity);
        },
        packaging(){
            return (this.packaging_fee * this.order.details.quantity);
        },
        total(){
            let total = this.productPrice + this.packaging;

            if(this.order.delivery.delivery_fee > 0){
                total += this.order.delivery.delivery_fee;
            }

            return total;
        },
        totalWithoutDeliveryFee(){
            return this.productPrice + this.packaging;
        },
        totalWithoutPackaging() {
            if(this.order.delivery.delivery_fee > 0){
                return this.productPrice + this.premiumSelectionsPrice + this.extraSelectionsPrice + this.order.delivery.delivery_fee + this.packaging;
            }
            return this.productPrice + this.premiumSelectionsPrice + this.extraSelectionsPrice
        },
        discount(){
            return {
                productPrice: this.calculateDiscount(this.productPrice),
                packaging: this.calculateDiscount(this.packaging),
                premiumSelectionsPrice: this.calculateDiscount(this.premiumSelectionsPrice),
                extraSelectionsPrice: this.calculateDiscount(this.extraSelectionsPrice),
                totalWithoutDeliveryFee: this.calculateDiscount(this.totalWithoutDeliveryFee, true),
                total: (this.totalWithoutDeliveryFee - this.calculateDiscount(this.totalWithoutDeliveryFee)) + this.order.delivery.delivery_fee,
                text: this.createDiscountText(),
            }
        }
    },
    methods:{
        selectionHasPremiumSelected(selection){
            return selection.options.filter(item => item.premium).length > 0;
        },
        selectionSelectedPremiumOptionsTotal(selection){
            return selection.options.filter(item => item.premium).map(item => item.price).reduce((acc, cur) => acc + cur);
        },
        selectionSelectedExtraOptionsTotal(selection){
            return selection.options.map(item => item.as_extra_price * this.order.details.quantity).reduce((acc, cur) => acc + cur);
        },
        calculateDiscount(amount, useDifference){
            if(!this.couponData){
                return 0;
            }

            if(this.couponData.in_percent){
                const percentage = this.couponData.value / 100;
                return amount * percentage;
            }


            const discount = amount - this.couponData.value;

            if(discount < 0){
                return amount;
            }

            return amount - discount;
        },
        createDiscountText(){
            if(!this.couponData){
                return;
            }

            if(this.couponData.in_percent){
               return `${this.couponData.value}%`;
            }

            return this.couponData.value;
        }
    }
}
